<template>
  <div id="app">
    
    <dbfunctions></dbfunctions>
    <headerblock></headerblock>
    <transition appear name="fade" mode="out-in">
      <!--<router-view v-bind:auth="auth" v-bind:contacts="contacts" v-bind:users="users" v-bind:currentUser="currentUser"></router-view>-->
      <router-view></router-view>
    </transition>
    <footerblock></footerblock>

  </div>
</template>

<script>

  import dbfunctions from './components/dbfunctions.vue'
  import headerblock from './components/headerblock.vue'
  import footerblock from './components/footerblock.vue'


  export default {
    components: {
      dbfunctions,
      headerblock,
      footerblock
    }
  }
</script>

<style>
/*!
  navbar fixing - increases height and ensures that page lays underneath correctly, fixes colours.
*/
  body { padding-top: 80px; }
  nav.navbar {
    opacity: 0.9;
  }
  .navbar-brand {
    padding: 0px;
    height: 80px;
  }
  .navbar-brand>img {
    height: 100%;
    padding: 15px;
    width: auto;
  }
  .nav >li >a {
    padding-top: 30px;
    padding-bottom: 30px;
  }
  .navbar-toggle {
    padding: 10px;
    margin: 25px 15px 25px 0;
  }
  nav.navbar-default .navbar-nav>li>a {
    color: #32c5d2;
    background-color: transparent;
  }
  nav.navbar-default .navbar-nav>.active>a {
    color: #777;
    background-color: transparent;
  }
  nav.navbar-default .navbar-nav>.active>a:hover {
    background-color: transparent;
  }

/*!
  General Helper Classes
 */
body {
  font-family: "Source Sans Pro", sans-serif;
  -webkit-font-smoothing: antialiased;
}
a {
  cursor: pointer;
}


/*!
  Front Banner Styling
 */
 div.frontBanner {
   background-image: url(assets/img/frontimg_1.png);
   background-size: cover;
   height: 600px;
   display: flex;
   align-items: center;
 }
 div.frontBanner h1 {
   font-weight: 900;
   font-size: 40px;
   letter-spacing: 1px;
   display: inline-block;
   text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.8);
    -moz-text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.8);
    -webkit-text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.8);
 }
 div.frontBanner h2 {
   letter-spacing: 1px;
   margin-bottom: 20px;
   display: inline-block;
   text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.8);
    -moz-text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.8);
    -webkit-text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.8);
 }
 div.frontBanner h3 {
   margin-bottom: 20px;
 }
 div.frontBanner button {
   margin-bottom: 20px;
 }
 div.frontBanner a {
   color: #fff;
 }


 /*!
   Main Content Styling
  */
 div.mainContent {
   margin-bottom: 40px;
 }
 div.mainContent h1 {
   font-weight: 900;
   font-size: 40px;
   letter-spacing: 1px;
 }
 div.mainContent h2 {
   letter-spacing: 1px;
   margin-bottom: 20px;
 }
 div.mainContent hr {
   width: 70px;
   border-top: 1px solid #000;
   margin-top: 40px;
 }

 /*!
   About Us Styling
  */
div.aboutAIDSImpact hr {
  width: 70px;
  border-top: 1px solid #000
}
div.aboutAIDSImpact p {
  margin-top: 10px;
  margin-bottom: 40px;
  line-height: 35px;
}

/*!
  Footer Styling
 */
footer.footerBlock {
  background-color: #000;
  color: #aeaeae;
  line-height: 24px;
  padding-top: 40px;
}
footer.footerBlock h4 {
  margin-bottom: 24px;
  color: #fff;
}
footer.footerBlock p {
  font-size: 13px;
}


/*!
  Transitions
 */
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-active {
  opacity: 0
}

/*!
  NEOTHER
 */

</style>



/** WEBPACK FOOTER **
 ** App.vue?3bbaa93d
 **/